import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import {clearStore} from './utils';
// slices
import customizerReducer from './slices/customizer';
import usersReducer from './slices/users';
import productsReducer from './slices/products';
import bookingsReducer from './slices/bookings';
import fileReducer from './slices/file';
import citiesReducer from './slices/cities';

// ----------------------------------------------------------------------

const createNoopStorage = () => ({
  getItem() {
    return Promise.resolve(null);
  },
  setItem(_key, value) {
    return Promise.resolve(value);
  },
  removeItem() {
    return Promise.resolve();
  },
});

const storage =
  typeof window !== 'undefined'
    ? createWebStorage('local')
    : createNoopStorage();

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const customizerPersistConfig = {
  key: 'customizer',
  storage,
  keyPrefix: 'redux-',
};

const usersPersistConfig = {
  key: 'users',
  storage,
  keyPrefix: 'redux-',
};

const productsPersistConfig = {
  key: 'products',
  storage,
  keyPrefix: 'redux-',
};

const bookingsPersistConfig = {
  key: 'bookings',
  storage,
  keyPrefix: 'redux-',
};

const filePersistConfig = {
  key: 'file',
  storage,
  keyPrefix: 'redux-',
};

const citiesPersistConfig = {
  key: 'cities',
  storage,
  keyPrefix: 'redux-',
};

const appReducer = combineReducers({
  customizer: persistReducer(customizerPersistConfig, customizerReducer),
  users: persistReducer(usersPersistConfig, usersReducer),
  products: persistReducer(productsPersistConfig, productsReducer),
  bookings: persistReducer(bookingsPersistConfig, bookingsReducer),
  file: persistReducer(filePersistConfig, fileReducer),
  cities: persistReducer(citiesPersistConfig, citiesReducer),
});

const rootReducer = (state, action) => {
  if (action.type === clearStore.type) {
    storage.removeItem('persist:root');
    storage.removeItem('persist:customizer');
    storage.removeItem('persist:users');
    storage.removeItem('persist:products');
    storage.removeItem('persist:bookings');
    storage.removeItem('persist:file');
    storage.removeItem('persist:cities');

    localStorage.clear();
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export {rootPersistConfig, rootReducer};
